<template>
    <base-button @click="handleClick"
               class="btn"
               :type="extraData.type ? extraData.type : 'default'"
               :size="extraData.size ? extraData.size : 'sm'"
               :icon="extraData.icon"
               :iconOnly="!extraData.text"
               :title="extraData.title ? extraData.title : null">
            <span v-if="extraData.text" class="btn-inner--text">
                {{extraData.text}}
            </span>
    </base-button>
</template>
<script>
import Event from "@/Event.js";
export default {
  name: "DTButton",
  data() {
    return {
        extraData: {},
    }
  },
  props: {
    data: Object,
  },
  methods: {
    handleClick() {
        Event.emit("Click", this.data, this.extraData.idClick ? this.extraData.idClick : null);
    }
  },
  created() {
      this.extraData = this.$attrs.column.extraData;
  },
};
</script>
<style>
</style>
